import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import NewsArticleStore from './store';
import cx from 'classnames';
import DateUtil from '@src/utils/date-util';
import { Checkbox, Pagination } from 'antd';

import NaviBar from '@src/business-components/navibar';
import styles from './index.less';
import Link from '@src/components/link';

const NewsArticle = ({ store }) => {
  store.use();
  // console.log(store.selList, '==kk store.selList');

  return (
    <Page className={styles.root}>
      <div className={styles.rootBox}>
        <div className={styles.naviBarBox}>
          <NaviBar store={store.navibarStore} />
        </div>
        <div className={styles.centent} id="home">
          <div className={styles.header}>
            <div className={styles.topTitle}>全部招募项目</div>
            <div className={styles.kv_bg} />
          </div>
          <div className={styles.listBox}>
            <div className={styles.listSelect}>
              <div className={styles.listSelect_title}>招募类型</div>
              <Checkbox.Group
                value={store.commitmentId}
                options={store.selList.map(option => ({ label: option.type_text, value: option.type_id }))}
                className={styles.listSelect_content}
                style={{ width: '100%' }}
                onChange={store.changeType}
              />
            </div>
            <div className={styles.listContent}>
              <div className={styles.listContent_title}>招募列表</div>
              <div className={styles.itemList}>
                {store.listData.map((item, index) => {
                  const day = new Date().getTime();
                  if (day > item.time * 1000) {
                    item.status = 2;
                  } else {
                    item.status = 1;
                  }
                  // console.log(item.status, '==item');

                  return (
                    <Link key={index} onClick={() => store.onDetailClick(item)}>
                      <div className={styles.item} key={item.contentIdKey}>
                        <div className={styles.item_bg} style={{ backgroundImage: `url(${item.item_bg})` }} />
                        <div className={styles.content}>
                          <div className={styles.item_title_box}>
                            <div
                              className={cx({
                                [styles.active]: item.status === 1,
                                [styles.normal]: item.status === 2
                              })}
                            >
                              {item.status === 1 ? '招募中' : '招募结束'}
                            </div>
                            <div className={styles.item_title}>{item.item_title}</div>
                          </div>
                          <div className={styles.item_content}>{item.info}</div>
                          <div className={styles.item_type_box}>
                            <div className={styles.item_type}>{item.type_text}</div>
                            <div className={styles.line} />
                            <div className={styles.item_time}>{DateUtil.formatDate(new Date(item.time * 1000), 'yyyy/MM/dd')}截止</div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
              {store.pageTotal > 0 && (
                <Pagination
                  size="small"
                  pageSize={store.pageSize}
                  className={styles.pagination}
                  current={store.pageNum}
                  onChange={store.changePage}
                  total={store.pageTotal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.leftA} />
      <div className={styles.leftB} />
      <div className={styles.hb}>
        <div className={styles.rightA} />
      </div>
    </Page>
  );
};

export default wrapStore(NewsArticle, NewsArticleStore);
